import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'row justify-content-md-center',
})`
  margin-top: 25px;

  @media (min-width: 576px) {
    .col-form-label {
      text-align: right;
    }
  }

  .numero-seguranca-tooltip {
    max-width: 315px;
    .numero-seguranca-tooltip-content {
      > p {
        font-weight: bold;
      }
      .info {
        > p {
          text-align: justify;
          margin-bottom: 0;
        }
      }
    }
  }

  .icon-numero-seguranca {
    margin-right: 3px;
    cursor: pointer;
  }

  .container-recaptcha {
    display: flex;
    justify-content: flex-end;
    @media (max-width: 576px) {
      justify-content: center;
    }
  }

  .btn-buscar {
    width: 100%;
    svg {
      margin-right: 5px;
    }
  }

  .base-mensagem-alerta {
    margin-top: 25px;
  }
`;
